import * as React from "react";
import PopoverMenu, { Item } from "components/PopoverMenu";
import { IconButton } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { IconButtonProps } from "@material-ui/core/IconButton";

export interface ThreeDotMenuProps {
  items: Item[];
  ariaLabel: string;
  buttonProps?: IconButtonProps;
  onChange?: (isOpen: boolean) => void;
  closeOnItemClick?: boolean;
}

const ThreeDotMenu = ({ items, ariaLabel, buttonProps, onChange, closeOnItemClick }: ThreeDotMenuProps) => {
  return (
    <PopoverMenu items={items} onChange={onChange} closeOnItemClick={closeOnItemClick}>
      {(_, openPopover) => (
        <IconButton
          data-testid="three-dot-menu-icon"
          onClick={openPopover}
          aria-label={ariaLabel}
          color="secondary"
          {...buttonProps}
        >
          <MoreHorizIcon />
        </IconButton>
      )}
    </PopoverMenu>
  );
};

export default ThreeDotMenu;
